import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX } = FiIcons;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Menu', path: '/menu' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/90 backdrop-blur-sm border-b border-gold-500/20">
      <div className="container mx-auto px-4">
        {/* Logo */}
        <div className="flex justify-center py-4">
          <Link to="/" className="text-center">
            <motion.h1 
              className="text-3xl md:text-4xl font-serif font-bold text-gold-400"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              ROYAL HOOKA
            </motion.h1>
            <p className="text-gold-300 text-sm tracking-wider">LUXURY LOUNGE</p>
          </Link>
        </div>

        {/* Navigation */}
        <nav className="border-t border-gold-500/20">
          {/* Desktop Menu */}
          <div className="hidden md:flex justify-center py-4">
            <ul className="flex space-x-8">
              {navItems.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.path}
                    className={`text-sm font-medium tracking-wider transition-colors hover:text-gold-400 ${
                      location.pathname === item.path ? 'text-gold-400' : 'text-white'
                    }`}
                  >
                    {item.name.toUpperCase()}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex justify-center py-4">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gold-400 p-2"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              className="md:hidden bg-black/95 border-t border-gold-500/20"
            >
              <ul className="py-4 space-y-2">
                {navItems.map((item) => (
                  <li key={item.name} className="text-center">
                    <Link
                      to={item.path}
                      className={`block py-2 text-sm font-medium tracking-wider transition-colors hover:text-gold-400 ${
                        location.pathname === item.path ? 'text-gold-400' : 'text-white'
                      }`}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.name.toUpperCase()}
                    </Link>
                  </li>
                ))}
              </ul>
            </motion.div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;